<template>

  <div
    class="body-info">
    <div
      class="body-info__title">
      Определение модели устройства по IMEI
    </div>
    <div
      class="body-info__content">

      <div
        class="body-info__content-line">
        <div
          class="body-info__content-line__input">
          <input
            type="text"
            class="inpt"
            maxlength="15"
            @input="SET_NUMBER({ number: $event.target.value.toUpperCase(), length: $event.target.value.toString().length})"
            :value="number"
            required="required" />
          <span
            class="hover">
            Например: 355352088044323
          </span>
        </div>
        <div
          class="body-info__content-line__length">
          {{ numberLength }} / 15
        </div>
      </div>

      <div
        class="body-info__content-line"
        v-for="(item, i) in items" :key="i"
        :class="item.active ? 'active' : ''">
        <div
          class="body-info__content-line__title"
          @click.prevent="activeItem(i)">
          {{ item.title }}
          <span
            class="icon"
            :class="item.active ? 'rotate' : ''">
            <img
              src="@/../static/img/icons/arrow.svg">
          </span>
        </div>
        <div
          class="body-info__content-line__text">
          {{ item.text }}
        </div>
      </div>

    </div>
  </div>

</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  data() {
    return {
      items: [
        {
          active: false,
          title: 'Как узнать IMEI iPhone XS, XS Max, XR, X, 8, 8 Plus, 7, 7 Plus, 6s, 6s Plus',
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In fermentum vel augue sit amet molestie. Proin ut diam nisi. Donec vel justo eget quam elementum dignissim eu nec orci. Etiam dui velit, venenatis id maximus sed, posuere at nisi. Integer consectetur rutrum quam in pellentesque. Quisque vulputate nisi a ultricies ultricies. Sed luctus arcu mauris, ut ultricies lacus aliquam in. Cras id purus massa. Quisque imperdiet at eros a pharetra.',
        },
        {
          active: false,
          title: 'Как узнать IMEI iPhone 6, 6 Plus, SE, 5s, 5c, 5',
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In fermentum vel augue sit amet molestie. Proin ut diam nisi. Donec vel justo eget quam elementum dignissim eu nec orci. Etiam dui velit, venenatis id maximus sed, posuere at nisi. Integer consectetur rutrum quam in pellentesque. Quisque vulputate nisi a ultricies ultricies. Sed luctus arcu mauris, ut ultricies lacus aliquam in. Cras id purus massa. Quisque imperdiet at eros a pharetra.',
        },
        {
          active: false,
          title: 'Как узнать IMEI iPhone 3G, 3GS, 4,4S',
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In fermentum vel augue sit amet molestie. Proin ut diam nisi. Donec vel justo eget quam elementum dignissim eu nec orci. Etiam dui velit, venenatis id maximus sed, posuere at nisi. Integer consectetur rutrum quam in pellentesque. Quisque vulputate nisi a ultricies ultricies. Sed luctus arcu mauris, ut ultricies lacus aliquam in. Cras id purus massa. Quisque imperdiet at eros a pharetra.',
        },
        {
          active: false,
          title: 'Как узнать IMEI устройства Android (например)',
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In fermentum vel augue sit amet molestie. Proin ut diam nisi. Donec vel justo eget quam elementum dignissim eu nec orci. Etiam dui velit, venenatis id maximus sed, posuere at nisi. Integer consectetur rutrum quam in pellentesque. Quisque vulputate nisi a ultricies ultricies. Sed luctus arcu mauris, ut ultricies lacus aliquam in. Cras id purus massa. Quisque imperdiet at eros a pharetra.',
        },
      ]
    }
  },
  computed: {
    ...mapState('buyphones', ['number', 'numberLength']),
  },
  methods: {
    ...mapMutations('buyphones', ['SET_NUMBER']),

    activeItem(id) {
      this.items.map((item, i) => {
        if (i == id) {
          if (item.active)
            item.active = false;
          else
            item.active = true;
        } else
          item.active = false;
      })
    }
  }
}
</script>

<style lang="css">
</style>
